import emailjs from '@emailjs/browser';
import { EMAIL_CONFIG } from './emailConfig';

/**
 * Servizio per l'invio di email tramite EmailJS
 */
class EmailService {
  constructor() {
    // Inizializza EmailJS con la tua public key
    emailjs.init(EMAIL_CONFIG.PUBLIC_KEY);
  }

  /**
   * Invia email generica
   * @param {Object} templateParams - Parametri del template
   * @param {string} templateId - ID del template (opzionale, usa quello di default)
   * @returns {Promise<{success: boolean, message: string}>}
   */
  async sendEmail(templateParams, templateId = EMAIL_CONFIG.TEMPLATE_ID) {
    try {
      const response = await emailjs.send(EMAIL_CONFIG.SERVICE_ID, templateId, {
        to_email: EMAIL_CONFIG.TO_EMAIL,
        ...templateParams,
        timestamp: new Date().toISOString(),
      });

      if (response.status === 200) {
        return {
          success: true,
          message: 'Email inviata con successo!',
        };
      } else {
        throw new Error(`Email service error: ${response.status}`);
      }
    } catch (error) {
      console.error('Errore invio email:', error);
      return {
        success: false,
        message: error.message || "Errore durante l'invio dell'email",
      };
    }
  }

  /**
   * Invia email per richiesta piano CrewBoat
   * @param {Object} planData - Dati del piano richiesto
   * @returns {Promise<{success: boolean, message: string}>}
   */
  async sendPlanRequest(planData) {
    const templateParams = {
      subject: `Nuova richiesta piano ${planData.planName} - CrewBoat`,
      plan_name: planData.planName,
      billing_period: planData.billingPeriod,
      company_name: planData.companyName || 'Non specificato',
      contact_name: planData.contactName,
      contact_email: planData.contactEmail,
      contact_phone: planData.contactPhone || 'Non specificato',
      vessel_count: planData.vesselCount || '1',
      crew_size: planData.crewSize || 'Non specificato',
      message: planData.message || 'Nessun messaggio aggiuntivo',
      request_type: 'Plan Request',
    };

    return await this.sendEmail(templateParams);
  }

  /**
   * Invia email per richiesta demo
   * @param {Object} demoData - Dati per la demo
   * @returns {Promise<{success: boolean, message: string}>}
   */
  async sendDemoRequest(demoData) {
    const templateParams = {
      subject: 'Nuova richiesta demo - CrewBoat',
      contact_name: demoData.contactName,
      contact_email: demoData.contactEmail,
      company_name: demoData.companyName,
      vessel_type: demoData.vesselType || 'Non specificato',
      preferred_date: demoData.preferredDate || 'Non specificato',
      message: demoData.message || 'Nessun messaggio aggiuntivo',
      request_type: 'Demo Request',
    };

    return await this.sendEmail(templateParams);
  }

  /**
   * Invia email di contatto generico
   * @param {Object} contactData - Dati di contatto
   * @returns {Promise<{success: boolean, message: string}>}
   */
  async sendContactMessage(contactData) {
    const templateParams = {
      subject: contactData.subject || 'Nuovo messaggio di contatto - CrewBoat',
      contact_name: contactData.name,
      contact_email: contactData.email,
      contact_phone: contactData.phone || 'Non specificato',
      message: contactData.message + ' ' + contactData.email,
      reply_to: contactData.email,
      request_type: 'Contact Message',
    };

    return await this.sendEmail(templateParams);
  }
}

// Esporta un'istanza singleton
export const emailService = new EmailService();
